// extracted by mini-css-extract-plugin
export default {"seoCrossLinksSection":"seoCrossLinksSection__ZGQyO","title":"title__NzFjN","list":"list__MjJmZ","link":"link__M2FjM"};